import { FC } from "react";
import { Plus } from "shared/assets/icons";

import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { colors } from "shared/styles/constants";

export interface LabelProps {
  label: string | JSX.Element;
  icon?: React.ComponentType<any>;
  isAddItem?: boolean;
}

export const Label: FC<LabelProps> = ({ icon, label, isAddItem }) => (
  <Spacer spaceDirection="horizontal" size="s" align="center" flexWrap="nowrap">
    {isAddItem && (
      <Icon
        as={Plus}
        isCircle={true}
        backgroundColor={colors.white}
        color={colors.black}
      />
    )}
    {icon && <Icon as={icon} color={colors.grey5} />}
    <span>{label}</span>
  </Spacer>
);
